import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Typography, Descriptions } from 'antd';
import { compliance } from '../config/compliance';
import LegalFooter from '../components/LegalFooter';

const { Title } = Typography;

export default function About() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f6f7fb', padding: '24px 16px 48px' }}>
      <div style={{ maxWidth: 820, margin: '0 auto' }}>
        <Title level={2}>关于百晓生</Title>

        <div style={{ marginBottom: 16 }}>
          <a
            href="/login"
            onClick={(e) => {
              e.preventDefault();
              navigate('/login');
            }}
          >
            返回登录
          </a>
        </div>

        <Card title="备案与合规" style={{ marginBottom: 12, borderRadius: 16 }}>
          <Descriptions column={1} size="small">
            <Descriptions.Item label="公司名称">{compliance.companyName}</Descriptions.Item>
            <Descriptions.Item label="APP备案号">{compliance.appFilingNumber}</Descriptions.Item>
            <Descriptions.Item label="ICP备案号">{compliance.icpFilingNumber}</Descriptions.Item>
            <Descriptions.Item label="支付状态">当前版本未开放应用内支付能力</Descriptions.Item>
          </Descriptions>
        </Card>

        <Card title="联系方式" style={{ marginBottom: 12, borderRadius: 16 }}>
          <Descriptions column={1} size="small">
            <Descriptions.Item label="官网">{compliance.websiteUrl}</Descriptions.Item>
            <Descriptions.Item label="支持邮箱">{compliance.supportEmail}</Descriptions.Item>
          </Descriptions>
        </Card>

        <LegalFooter />
      </div>
    </div>
  );
}
